import { createI18n } from 'vue-i18n'
import { localeString } from './storage.js'

const language = (window?.navigator?.languages && window?.navigator?.languages[0]) ||
            window?.navigator?.language ||
            window?.navigator?.userLanguage ||
            window?.navigator?.browserLanguage

export const locale = localeString() || (language && language?.split('-')[0])
const supportedLocales = ['ja', 'en']

export const I18n = createI18n({
  locale: supportedLocales.includes(locale) ? locale : 'ja',
  fallbackLocale: 'ja',
  messages: {
    ja : require('../../locales/ja.json'),
    en : require('../../locales/en.json')
  }
})

export const i18n = I18n.global
